import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-vms",
  "use": "icon-vms-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-vms\"><path d=\"M160 320A160 160 0 1 1 320 160 160 160 0 0 1 160 320z m0-256A96 96 0 1 0 256 160 96 96 0 0 0 160 64zM512 320a128 128 0 1 1 128-128 128 128 0 0 1-128 128z m0-192a64 64 0 1 0 64 64 64 64 0 0 0-64-64zM672 1024H32a32 32 0 0 1-32-32v-576A32 32 0 0 1 32 384h640a32 32 0 0 1 32 32v144.64L979.84 448a30.08 30.08 0 0 1 30.08 0 30.72 30.72 0 0 1 14.08 32v448a30.72 30.72 0 0 1-14.08 26.24 30.08 30.08 0 0 1-30.08 3.2L704 847.36v144.64a32 32 0 0 1-32 32zM64 960h576v-160a30.72 30.72 0 0 1 14.08-26.24 30.08 30.08 0 0 1 30.08-3.2L960 880.64V527.36L684.16 640a30.08 30.08 0 0 1-30.08-3.2 30.72 30.72 0 0 1-14.08-28.8V448H64z\" fill=\"#BFCBD9\" p-id=\"4399\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/vms.svg
// module id = Xacy
// module chunks = 62